import { render, staticRenderFns } from "./_FormNew.vue?vue&type=template&id=b990ed2e"
import script from "./_FormNew.vue?vue&type=script&lang=js"
export * from "./_FormNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports